import React, {useEffect, useState} from 'react'
import { useParams } from 'react-router-dom';
import logo from "../../../assets/images/logo_nsf.png"
import "./coa.css";
import SamplePreparationService from '../../../service/SamplePreparation.service';
import { Modal } from 'antd';
import { Flex, Space } from 'antd';
import dayjs from 'dayjs';
import { capitalized } from '../../../utils/util';
 

const spService = SamplePreparationService();

/* จำนวนบรรทัดส่วนผสมสูงสุดที่คอลัมน์ซ้ายรับได้ก่อนจะไปทับบล็อก
   Allergen / Shelf life / Storage ที่ตรึงไว้ท้ายหน้า
   (พื้นที่ ~154mm ต่อบรรทัด ~5.3mm) เกินจากนี้จะยกไปต่อในคอลัมน์ Parameter */
const ING_LEFT_MAX = 20;

export default function CoaPrintPreview() {
    // const location = useLocation();
    const { code } = useParams();

    const [header, setHeader] = useState({});
    const [coa, setCoa] = useState([]);
    const [parmeter, setParameter] = useState([]);
    const [allergens, setAllergens] = useState(null);

    const getBBE = (header) => {
        const { spdate, shelf_life, shelf_life_unit } = header; 

        if( !!spdate && !!shelf_life ) {
            const newDateAfterAdding = dayjs(spdate).add(Number(shelf_life), shelf_life_unit);
            const bbe_date = newDateAfterAdding.format("YYYY-MM-DD");

            setHeader(state => ({...state, bbe_date}));

            return bbe_date;
        } return null;
    }

    useEffect( () => { 
        const getData = () => {
            spService.coa(code).then( async (res) => {  
                const { data : { header, coa, parm, allergen:{allergen} } } = res.data;
                if(!!allergen){
                    const allergenArr = [...new Set(allergen.split(","))].map( srt => capitalized(srt));
    
                    setAllergens(allergenArr.join(", "));
                }
                setHeader(header);
                setCoa(coa);
                setParameter(parm);
            }).catch( err => { 
                console.log(err);
                const { data } = err.response
                Modal.error({
                title: 'Error Request.',
                content: data || 'Request Fail. Please try again.',
                onOk: () => window.close()
                })            
            });
        }
    
        getData();
    }, [code])

    /* ส่วนผสมยาวเกินคอลัมน์ซ้าย ให้ยกส่วนที่เหลือไปต่อในคอลัมน์ Parameter
       กันไม่ให้ไปทับบล็อก Allergen / Shelf life / Storage ท้ายหน้า */
    const ingredientsLeft  = coa.slice(0, ING_LEFT_MAX);
    const ingredientsRight = coa.slice(ING_LEFT_MAX);

    return (
        <div className='page-show' id="coa"> 
            <div className="print-layout">
                <div className='print-head'>
                    <div className='print-logo'>
                        <img src={logo} alt="" style={{paddingInline: 6}} /> 
                    </div>
                    <p className='th-text' style={{textAlign:'center', marginBottom:2}}>NINE STAR FOOD CO., LTD.</p>
                    <p className='ts-text' style={{textAlign:'center'}}>99/9 Moo8, Tambon Kongdin, Amphoe Klaeng, Rayong 22160</p>
                </div>
                <div className='print-head-content'> 
                    <p style={{textAlign:'center', marginBottom:2, fontWeight:700, fontSize:'15pt', color:'#000'}}>SAMPLE COA</p>
                    {/* ชื่อสินค้ายาว จึงให้กินพื้นที่เต็มแถว ไม่ต้องแบ่งครึ่ง */}
                    <div className='h-group-text'>
                        <span className='h-label'>Product Name </span>
                        <span className='h-text'>{header.spname}</span>
                    </div>
                    {/* ที่เหลืออ่านจากซ้ายไปขวา : Sample No → Sample Lot Date → BBE → Package */}
                    <Flex>
                        <Flex vertical className='w-1/2 flex-grow'>
                            <div className='h-group-text'>
                                <span className='h-label'>Sample No </span>
                                <span className='h-text'>{header.spcode}</span>
                            </div>
                            <div className='h-group-text'>
                                <span className='h-label'>Best Before End (BBE) </span>
                                <span className='h-text'>
                                    {(() => { const d = header.bbe_date || getBBE(header); return d ? dayjs(d).format("DD/MM/YYYY") : ""; })()}
                                </span>
                            </div>
                        </Flex>
                        <Flex vertical className='w-1/2 flex-grow-0' style={{width:340}}>
                            <div className='h-group-text'>
                                <span className='h-label'>Sample Lot Date </span>
                                <span className='h-text'> {dayjs(header.spdate).format("DD/MM/YYYY")}</span>
                            </div>
                            <div className='h-group-text'>
                                <span className='h-label'>Package</span>
                                <span className='h-text'> {header.pkname}</span>
                            </div>
                        </Flex>
                    </Flex>
                </div>
                <div className='print-content'> 
                    <Flex align='center'>
                        <div className='sec-item h-group-text'>
                            <span className='h-title'>Ingredients: In Descending order</span>
                        </div>                        
                        <div className='sec-parm h-group-text'>
                            { ingredientsRight.length > 0
                                ? <span className='h-title'>Ingredients: (continued)</span>
                                : <>
                                    <span className='h-title'>Physical & Chemical</span>
                                    <span className='h-title'>parameters:</span>
                                  </>
                            }
                        </div>
                    </Flex>
                    <Flex align='flex-start' style={{paddingBlock:'2mm'}}>
                        <div className='sec-item h-group-text'>
                            { ingredientsLeft.map( ( m, i ) => (
                                <Flex justify='start' key={`${String(i)?.padStart(4, '0')}`}>
                                    <span className='c-text' style={{width:'94mm'}}>{m.stnameEN}</span>
                                    <span className='c-text'>{m.res}</span>
                                </Flex>
                            )) }
                        </div>
                        <div className='sec-parm h-group-text'>
                            {/* ส่วนผสมที่ล้นจากคอลัมน์ซ้าย มาต่อด้านบน ก่อนตาราง Parameter */}
                            { ingredientsRight.length > 0 && (
                                <div className='coa-ing-cont'>
                                    { ingredientsRight.map( ( m, i ) => (
                                        <Flex justify='start' key={`c${String(i)?.padStart(4, '0')}`}>
                                            <span className='c-text' style={{flex:'1 auto'}}>{m.stnameEN}</span>
                                            <span className='c-text' style={{width:'22mm', justifyContent:'flex-end', textAlign:'end'}}>{m.res}</span>
                                        </Flex>
                                    )) }
                                    <div className='coa-parm-title'>
                                        <span className='h-title'>Physical & Chemical parameters:</span>
                                    </div>
                                </div>
                            )}
                            <Flex justify='space-between'>
                                <span className='c-text' style={{textDecoration:'underline'}}>Parameter</span>
                                <span className='c-text' style={{textDecoration:'underline', paddingRight: '4.6mm', width: '32mm', justifyContent:'flex-end', textAlign:'end'}}>Result</span>
                            </Flex>
                            { parmeter.map( ( m, i ) => (
                                <Flex justify='start' key={`${String(i)?.padStart(4, '0')}`}>
                                    <span className='c-text' style={{flex:'1 auto'}}>{m.paraname}</span>
                                    <span className='c-text' style={{paddingRight: '4.6mm', width: '32mm', justifyContent:'flex-end', textAlign:'end'}}>{m.cutout || 0}</span> 
                                </Flex>
                            )) }                            
                            <Flex justify='start'>
                                <span className='c-text' style={{flex:'1 auto'}}>Net weight (gm)</span>
                                <span className='c-text' style={{paddingRight: '4.6mm', width: '32mm', justifyContent:'flex-end', textAlign:'end'}}>{header.netweight}</span>
                            </Flex>
                        </div>
                    </Flex>
                    <div style={{position:'absolute', bottom:15}}>
                        <Space direction='vertical' size='small'> 
                            {   (!!allergens || !!header.allergen_standards) &&
                                <Flex vertical> 
                                    <span className='h-title' >Allergen information: 
                                        { <span style={{fontWeight:400, fontStyle:'italic', marginLeft:8}}>{allergens || 'none'}</span> }
                                    </span>
                                    {
                                        !!header.allergen_standards &&
                                        <Flex vertical> 
                                            <span className='c-text' >{header.allergen_standards}</span>
                                        </Flex>  
                                    }
                                </Flex>                                
                            } 
                            {
                                !!header.shelf_life &&
                                <Flex vertical>
                                    <span className='h-title'>Shelf life</span>
                                    <span className='c-text'>{header.shelf_life} {header.shelf_life_unit}</span>
                                </Flex> 
                            }            
                            {
                                !!header.storage_conditions &&
                                <Flex vertical>
                                    <span className='h-title' >Storage Conditions</span>
                                    <span className='c-text' >{header.storage_conditions}</span>
                                </Flex> 
                            }       
                            {
                                header.additional &&
                                <Flex vertical>
                                    <span className='h-title' >Additional</span>
                                    <span className='c-text' >{header.additional}</span>
                                </Flex> 
                            }       
                        </Space>
                   
                    </div>                
                </div>
                <div className='print-foot'>  
                    <Flex vertical>
                        <div className='h-group-text'>
                            <span className='h-label'>Prepared/Approved by</span>
                            <span className='h-text'> {header.approved_name} </span>
                        </div>
                        <div className='h-group-text'>
                            <span className='h-label'>Date</span>
                            {/* <span className='h-text'> {dayjs().format("DD/MM/YYYY")} </span> */}                            
                            <span className='h-text'> {dayjs(header.spdate).format("DD/MM/YYYY")} </span>
                        </div>
                        <div className='h-group-text'>
                            <span className='h-label'>Note</span>
                            <span className='h-text'></span>
                        </div>
                    </Flex> 
                </div>
            </div> 
        </div>
    )
}
